const WORD_NUMBERS: Record<string, number> = {
  one: 1,
  two: 2,
  three: 3,
  four: 4,
  five: 5,
  six: 6,
  seven: 7,
  eight: 8,
  nine: 9,
  ten: 10,
  first: 1,
  second: 2,
  third: 3,
  fourth: 4,
  fifth: 5,
  sixth: 6,
  seventh: 7,
  eighth: 8,
  ninth: 9,
  tenth: 10,
};

const SELECTION_VERBS = /\b(select|choose|pick|open|use|go|number|option|item|that'?s?|its?)\b/;

function findNumber(text: string): number | null {
  const digitMatch = text.match(/\b(10|[1-9])\b/);
  if (digitMatch) return Number(digitMatch[1]);

  const tokens = text.split(/[\s,.!?;:'"()-]+/).filter(Boolean);
  for (const token of tokens) {
    if (token in WORD_NUMBERS) return WORD_NUMBERS[token];
  }
  return null;
}

/**
 * Extracts a 1-10 selection from a user phrase.
 *
 * Returns a number if:
 *   - the text is *only* a number ("8", "eight", "10"), OR
 *   - the text contains a selection verb (select/choose/pick/open/number/option) AND a number.
 *
 * Returns null otherwise. This is deliberately strict so phrases like
 * "find me 8 domains for AI" do NOT auto-select option 8.
 */
export function parseSelection(text: string): number | null {
  if (!text) return null;
  const cleaned = text.toLowerCase().trim();
  if (!cleaned) return null;

  const tokens = cleaned.split(/[\s,.!?;:'"()-]+/).filter(Boolean);

  if (tokens.length === 1) {
    const only = tokens[0];
    if (/^(10|[1-9])$/.test(only)) return Number(only);
    if (only in WORD_NUMBERS) return WORD_NUMBERS[only];
    return null;
  }

  if (SELECTION_VERBS.test(cleaned)) {
    return findNumber(cleaned);
  }

  return null;
}
